'use client'

import { createContext, useContext } from 'react'

export const SectionErrorBoundaryResetContext = createContext<(() => void) | undefined>(undefined)

export function useSectionErrorBoundaryReset(): (() => void) | undefined {
  return useContext(SectionErrorBoundaryResetContext)
}
